export default "__VITE_ASSET__rBdaDyeJ__"